<template>
  <div>
    <v-row>
      <v-col cols="12" sm="9" lg="10">
        <v-text-field
          v-model="thesis.doctoral_program"
          :label="$t('form.thesis.doctoral_program')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3" lg="2">
        <v-checkbox
          readonly
          v-model="thesis.international_phd"
          :label="$t('form.thesis.international_phd')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          :value="thesis.start_date"
          :label="$t('form.thesis.start_date')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="thesis.deposit_date"
          :label="$t('form.thesis.deposit_date')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="thesis.estimated_end_date"
          :label="$t('form.thesis.estimated_end_date')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="thesis.read_center"
          :label="$t('form.thesis.read_center')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="thesis.grade"
          :label="$t('form.thesis.grade')"
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="thesis.lecture_date"
          :label="$t('form.thesis.lecture_date')"
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="directors"
          :label="$t('form.thesis.directors')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="tutor"
          :label="$t('form.thesis.tutor')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DetailThesis",
  props: {
    thesis: Object
  },
  data: () => ({
    directors: "",
    tutor: ""
  }),

  created() {
    this.getNameDirectors();
    this.getTutor(this.thesis.tutor);
  },

  methods: {
    getTutor(id) {
      let path = this.$store.state.endpoint + "/person/" + id;
      axios
        .get(path)
        .then(response => {
          this.tutor =
            response.data.preferred_name.given_name +
            " " +
            response.data.preferred_name.family_name;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getNameDirectors() {
      this.thesis.directors.forEach(director => {
        this.directors === ""
          ? (this.directors =
              director.position +
              "- " +
              director.person.preferred_name.given_name +
              " " +
              director.person.preferred_name.family_name)
          : (this.directors +=
              ", " +
              director.position +
              "- " +
              director.person.preferred_name.given_name +
              " " +
              director.person.preferred_name.family_name);
      });
    }
  }
};
</script>

<style scoped></style>
